var ErrorHandler = /** @class */ (function () {
    function ErrorHandler() {
    }
    ErrorHandler.handelError = function (error) {
        console.log(error);
    };
    return ErrorHandler;
}());
export { ErrorHandler };
//# sourceMappingURL=errorHandler.js.map